import { Typography } from "antd";
import classNames from "classnames";
import { MaterialDetailsData } from "./types";

const { Paragraph } = Typography;

function DetailField({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="text-sm text-color-1">{label}</div>
      <div className="text-sm text-color-3 mt-1">{value}</div>
    </div>
  );
}

function MaterialDetailsSidebar({
  data,
  className,
  showTitle = true
}: {
  data: MaterialDetailsData;
  className?: string;
  showTitle?: boolean;
}) {
  return (
    <div
      className={classNames(
        "w-full lg:w-[280px] xl:w-[320px] shrink-0 lg:h-full overflow-y-auto px-4 lg:px-6 py-5 space-y-5",
        className
      )}
      data-testid="material-details-sidebar"
    >
      {showTitle && (
        <div className="text-sm font-semibold text-color-1">
          Material Details
        </div>
      )}
      <DetailField label="Current status" value={data.currentStatus} />
      <DetailField label="Next Milestone" value={data.nextMilestone} />
      {data.specSection && (
        <DetailField label="Spec Section" value={data.specSection} />
      )}
      {data.tag && <DetailField label="Tag" value={data.tag} />}
      {data.description && (
        <div>
          <div className="text-sm text-color-1">Description</div>
          <div className="text-sm text-color-3 mt-1">
            <Paragraph className="!mb-0">{data.description}</Paragraph>
          </div>
        </div>
      )}
    </div>
  );
}

export default MaterialDetailsSidebar;
